<script>
import {fileToBase64} from '../../../../_default/utils/fileToBase64'
import {deleteArquivoGrv, uploadArquivoScan} from '../../../../../domain/grv/services'

const TIPO_ARQUIVO_SCAN = 9

export default {
  name: 'BtnUploadArquivoGrv',
  props: {
    grv: {
      type: Object,
      required: true
    },
    disabled: Boolean
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    arquivoScanGrv () {
      return this.grv.arquivos.find(a => a.tipo === TIPO_ARQUIVO_SCAN)
    }
  },
  methods: {
    openMultipleInputFile () {
      this.$refs['uploadScanGrv'].click()
    },
    uploadDocumento: async function (e) {
      this.loading = true
      const file = await fileToBase64(e.target.files[0])
      try {
        await uploadArquivoScan(this.grv.id, {data: file, filename: 'arquivoScanGrv'})
        this.$emit('reload')
      } catch (error) {
        console.log('Erro ao enviar o arquivo: ', error)
        alert('Erro ao enviar o arquivo')
      } finally {
        this.clearInputFiles()
        this.loading = false
      }
    },
    clearInputFiles () {
      if (this.$refs.uploadScanGrv) {
        this.$refs.uploadScanGrv.value = ''
      }
    },
    deleteDocumento: async function () {
      const confirm = window.confirm('Tem certeza de que deseja excluir o arquivo de scan?')
      if (!confirm) return

      this.loading = true
      this.$loaderOverlay.open()
      try {
        await deleteArquivoGrv(this.arquivoScanGrv.id)
        this.$emit('reload')
      } catch (error) {
        console.log('Ocorreu um erro ao remover o arquivo.', error)
        alert('Ocorreu um erro ao remover o arquivo.')
      } finally {
        this.clearInputFiles()
        this.loading = false
        this.$loaderOverlay.hide()
      }
    }
  }
}
</script>

<template>
  <div>
    <div v-if="!!arquivoScanGrv">
      <button type="button" class="btn btn-danger btn-block" @click.stop.prevent="deleteDocumento">
        <i class="fa fa-trash-o m-r-xs"></i> Excluir Arquivo Scan
      </button>
    </div>
    <div v-else>
      <button type="button" class="btn btn-default btn-block" @click.stop.prevent="" v-if="loading">
        <i class="fa fa-spinner fa-spin m-r-xs"></i>
      </button>
      <button type="button" class="btn btn-default btn-block" @click="openMultipleInputFile" :disabled="disabled" v-else>
        <i class="fa fa-upload m-r-sm"></i><slot>Upload file</slot>
      </button>
      <input type="file" name="files[]" id="fileInptImg" ref="uploadScanGrv" @change="uploadDocumento" v-show="false" accept="application/pdf">
    </div>
  </div>
</template>

<style scoped>
</style>



// WEBPACK FOOTER //
// BtnUploadArquivoGrv.vue?de31f5b6